import { useRolGetAll } from "../../../fnx/rol/rolGetAll";
import { useEffect, useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var useDataRoles = function () {
    var trigger = [true][0];
    var clientId = useState(findParamInLocalStorage("clientId"))[0];
    var _a = useState([]), rolesList = _a[0], setRolesList = _a[1];
    var _b = useRolGetAll(trigger, clientId !== null && clientId !== void 0 ? clientId : "", 1, 1000), responseRol = _b.responseRol, errorRol = _b.errorRol, loadingRol = _b.loadingRol;
    useEffect(function () {
        if ((responseRol === null || responseRol === void 0 ? void 0 : responseRol.length) > 0) {
            var newRolesList = responseRol.map(function (role) { return ({
                id: role.id,
                name: role.name,
                description: role.description,
            }); });
            setRolesList(newRolesList);
        }
    }, [responseRol]);
    return { rolesList: rolesList, errorRol: errorRol, loadingRol: loadingRol };
};
